// extracted by mini-css-extract-plugin
module.exports = {"trialHeader":"style_trialHeader__khftj","title":"style_title__e1mku","pic":"style_pic__ySqwr"};